var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadingUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_1560_25339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1560_25339",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1560_25339",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1560_25339",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACx0lEQVR4nO3czWsTQRjH8VXwFa+CQpnHw55y9Y/y5Z/waPSgFSMYnCH3Hj2I/4CK2oPzkJMXL75UEFsN2mPk6QbZdHeT3fTZCZn9fWGgJGHSfjrZkNltkwQhhBBCCOXq7YzPkuV75PxXcvyFHPfltvxjkEICS46nx0ZfY26Ua7aS56CN9d/yj0EKzQ4X8yva8meNudGSQ4ex/m7+MUjrzTDDlpWNN0OEEEIIoc2uh72OMBH2OkJBe+x1hIFm7HUEgu5jryNAPex1IIQQQihsd6anQd5iWzuvL5DlgXF8IIOcfyy3AV05crxd/MDCDwCtnHF+rwT6O6CVo+JVSkcD0IDezAgrGtBRRVjRgI4qwooGdFQRVjSgo4qwogEdVYQVDeioolVXtJyR6fJZma3sjMmQHP8h63+Q4/vpo4/ntKBlLjkLI/Mb6w+N49HlwfhS0rUoQz6+kf+iCrsJtMwhcxXmdzxKOtV0eoqcn5TBVWHXha5Cnv1d4mHnDiPG+d9VeGXYdaAXIWfDT+SXnHQpY/lhNUgRexn0cuSjsZ1sRIovu7QGTB57EXTTuU6cvCraeGW0dU1F2gCo6v6QyFeHuxeN80/J8l8Z8rXqtSVtXlOR1oRa5T7tlWwcPyk8h+WBxtwLrqnQ+18Zab3ja+OherjI3lf2S57n50btM/SyK/qfKyK/pNGn85rfY+sOIaA1sdtAjgpaA7st5OigT4LdJnKU0Ktgt40cLXQT7BDIUUPXwQ6FHD30IuyQyJ2ALsMOjdwZ6Dz2OpA7BS3JR2rNj9VN6hT0OgN0oAAdKEAHCtCBAnSgAB0PdPnFLhgsp/R+qUEbx2+AyuULy/pXatBk/W1AcwU031TeY/Dvgc3zu4eO314f7p5JNKPR+ApZ/w7Y/B9ZTJI2kt8euQ+35LjUzTdIP5Gf/dozvqG+khFCCCGEEEIoWVP/AHD8s6tRQVCkAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadingUpdates);
export default __webpack_public_path__ + "static/media/Downloading Updates.814fa51fe830e85d08383ca587f59c28.svg";
export { ForwardRef as ReactComponent };